export const barLineOpt = {
  color: ["#3D7CF9", "#FD5F5F", "#8dc6ff", "#febbbb", "#6EA4E1"],
  title: {
    text: "",
    top: 5,
    left: "center",
    textStyle: {
      fontSize: 16,
      color: "#274b6d",
      fontWeight: "500",
    },
  },
  grid: {
    left: 30,
    right: 30,
    bottom: 25,
    containLabel: true,
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    top: "15",
  },
  xAxis: [
    {
      type: "category",
      data: [],
      axisPointer: {
        type: "shadow",
      },
      axisLabel: {
        rotate: 45,
        fontSize: 11,
        color: "#666",
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      axisLabel: {
        color: "#000",
        fontSize: 11,
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#c0c0c0",
        },
      },
    },
    {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#c0c0c0",
        },
      },
      axisLabel: {
        color: "#000",
        fontSize: 11,
      },
    },
  ],
  series: [],
};
